import React from "react";
import OperationHistoryComponent from "./OperationHistory";

interface OperationHistoryViewProps {
  artworkId: string;
}

// Wrapper per la vista delle operazioni (form chiuso di default)
const OperationHistoryView: React.FC<OperationHistoryViewProps> = ({
  artworkId,
}) => {
  return (
    <OperationHistoryComponent artworkId={artworkId} defaultShowForm={false} />
  );
};

export default OperationHistoryView;
